import React, { Component } from 'react';
import SliderHandle from './slider_components/SliderHandle';
import './Slider.css';
import ParameterErrors from '../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
export default class Slider extends Component{
    constructor(props) {
        super(props);
        const { min, max, initial, onValueChanged, isHorizontal } = props;
        this._onValueChanged = onValueChanged;
        if (min === undefined) throwNotProvided("min");
        if (max === undefined) throwNotProvided("max");
        if (initial === undefined) throwNotProvided("initial");
        this._min = min;
        this._max = max;
        this._initial = initial;
        this._isHorizontal = isHorizontal?true:false;
		this._sliderHandle = React.createRef();
        this._inner = React.createRef();
		this.setValue = this.setValue.bind(this);
        this._constrainValue = this._constrainValue.bind(this);
        this._sliderHandleMoved = this._sliderHandleMoved.bind(this);
        this.setMin = this.setMin.bind(this);
        this.setMax = this.setMax.bind(this);
        this._updateSliderHandlePosition = this._updateSliderHandlePosition.bind(this);
        this._calculateAndDispatchNewValue = this._calculateAndDispatchNewValue.bind(this);
        this._setSliderPositionFromValue = this._setSliderPositionFromValue.bind(this);
        this.setFromInitialValue = this.setFromInitialValue.bind(this);
    }
	get handle(){
		return this._sliderHandle.current;
	}
    _sliderHandleMoved(dX, dY) {
        this._updateSliderHandlePosition(dX, dY);
    }
    _updateSliderHandlePosition(dX, dY) {
        const sliderHandle = this._sliderHandle.current;
        const inner = this._inner.current;
        const startPosition = sliderHandle.startPosition;
		if(this._isHorizontal){
			let newX = startPosition.x + dX;
			const innerWidth = inner.offsetWidth;
			if (newX < 0) newX = 0;
			else if (newX > inner.offsetWidth) newX = innerWidth;
			sliderHandle.setPosition({ x: newX, y: 0 });
			this._calculateAndDispatchNewValue(newX, innerWidth);
			return;
		}
        let newY = startPosition.y + dY;
        const innerHeight = inner.offsetHeight;
        if (newY < 0) newY = 0;
        else if (newY > inner.offsetHeight) newY = innerHeight;
        sliderHandle.setPosition({ x: 0, y: newY });
        this._calculateAndDispatchNewValue(newY, innerHeight);
    }
	setMin(value){
		this._min = value;
		this._constrainValue(this._value);
		this._setSliderPositionFromValue(this._value);
	}
	setMax(value){
		this._max = value;
		this._constrainValue(this._value);
		this._setSliderPositionFromValue(this._value);
	}
	setFromInitialValue(){
        this._setSliderPositionFromValue(this._initial);
	}
	setValue(value){
		this._setSliderPositionFromValue(value);
	}
    _calculateAndDispatchNewValue(newDesired, innerLength) {
		this._constrainValue(newDesired);
        this._onValueChanged(this._value);
    }
	_constrainValue(newDesired){
		const inner = this._inner.current;
		const innerLength = this._isHorizontal?inner.offsetWidth:inner.offsetHeight
        this._value = this._max - ((this._max - this._min) * (innerLength - newDesired) / innerLength) ;
	}
    _setSliderPositionFromValue(value) {
		if(this._isHorizontal){
			const innerWidth = this._inner.current.offsetWidth;
			const newX = innerWidth -((this._max - value) * innerWidth / (this._max - this._min));
			const sliderHandle = this._sliderHandle.current;
			sliderHandle.setPosition({ x: newX, y: 0 });
			return;
		}
        const innerHeight = this._inner.current.offsetHeight;
        const newY = innerHeight -((this._max - value) * innerHeight / (this._max - this._min));
        const sliderHandle = this._sliderHandle.current;
        sliderHandle.setPosition({ x: 0, y: newY });
    }
    componentDidMount() {
        this._setSliderPositionFromValue(this._initial);
    }
    render() {
		let className = "slider "+(this._isHorizontal?" horizontal":" vertical");
        return (
            <div className={className}>
                <div className="inner" ref={this._inner}>
                    <SliderHandle ref={this._sliderHandle} callbackMoved={this._sliderHandleMoved}></SliderHandle>
                </div>
            </div>    
        );
    }
}